import { StateGenaral } from './app.state';
import { ActionType } from './app.actions';
const initialState: StateGenaral = {
    type: 'unkun',
    selectbed: {
        bedSelected: { key: '', val: [] },
        idRoom: 0
    },
    incrementStockCombine: {
        combineIncremented: {},
        indexSearch: ''
    },
};

export function reducerGenaral(state: StateGenaral = initialState, action) {
    switch (action.type) {
        case ActionType.SelectBedRoom:
            return {
                ...state, type: action.type, selectbed: action.payload
            };
        case ActionType.incrementStockCombine:
            return {
                ...state, type: action.type, incrementStockCombine: action.payload
            };
        default:
            return state;
    }
}